import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import DataMapper from '../components/DataMapper';
import EventViewer from '../components/EventViewer';

const hasAnEventMappingConfiguration = (mapping) =>
	typeof Object.values(mapping).find(
		(val) => typeof val.event !== 'undefined'
	) !== 'undefined';

const eventViewerInitialState = (win) => {
	let show = false;

	if (new URL(win.location).searchParams.get('eventViewer') === 'false') {
		show = false;
	} else if (win.localStorage.getItem('eventViewer') === 'true') {
		show = true;
	} else if (
		new URL(win.location).searchParams.get('eventViewer') === 'true'
	) {
		show = true;
		window.localStorage.setItem('eventViewer', 'true');
	}

	return show;
};

export class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			eventViewer: false,
			eventViewerData: [],
			eventViewerCount: 0
		};
		this.handleEventViewerData = this.handleEventViewerData.bind(this);
		this.handleKeydown = this.handleKeydown.bind(this);
	}

	componentDidMount() {
		this.setState(() => ({
			eventViewer: eventViewerInitialState(window)
		}));
		window.DDC = window.DDC || {};
		window.DDC.WidgetData = window.DDC.WidgetData || {};
		window.DDC.WidgetData['ws-tagging'] =
			window.DDC.WidgetData['ws-tagging'] || {};
		window.DDC.WidgetData['ws-tagging'].mapping = this.props.mapping;
		if (window && window.DDC && window.DDC.pubsub) {
			window.DDC.pubsub.publish('ws-tagging-ready');
		}

		window.addEventListener('eventViewerData', this.handleEventViewerData);

		window.addEventListener('keydown', this.handleKeydown);
	}

	componentWillUnmount() {
		window.removeEventListener(
			'eventViewerData',
			this.handleEventViewerData
		);
		window.removeEventListener('keydown', this.handleKeydown);
	}

	handleEventViewerData({ detail }) {
		this.setState(({ eventViewerData, eventViewerCount }) => {
			const newEventViewerData = JSON.parse(
				JSON.stringify(eventViewerData)
			);
			let newEventViewerCount = eventViewerCount;

			if (detail) {
				newEventViewerCount += 1;
				newEventViewerData.unshift({
					detail,
					eventViewerCount: newEventViewerCount
				});
			}

			return {
				eventViewerData: newEventViewerData,
				eventViewerCount: newEventViewerCount
			};
		});
	}

	handleKeydown({ altKey, ctrlKey, metaKey, shiftKey, key }) {
		if (
			altKey &&
			ctrlKey &&
			metaKey &&
			shiftKey &&
			['∆', 'Î'].includes(key)
		) {
			this.setState(
				({ eventViewer }) => ({
					eventViewer: !eventViewer
				}),
				() => {
					window.localStorage.setItem(
						'eventViewer',
						this.state.eventViewer
					);
				}
			);
		}
	}

	render() {
		return (
			<React.Fragment>
				{hasAnEventMappingConfiguration(this.props.mapping) && (
					<DataMapper mapping={this.props.mapping} />
				)}
				{this.state.eventViewer && (
					<EventViewer data={this.state.eventViewerData} />
				)}
			</React.Fragment>
		);
	}
}

WidgetContainer.propTypes = {
	mapping: PropTypes.objectOf(PropTypes.object)
};

const mapStateToProps = (state) => {
	return {
		mapping: state.mapping
	};
};

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
